import React, { useState } from 'react';
import { Header } from './components/Header';
import { HeroSection } from './components/HeroSection';
import { AboutSection } from './components/AboutSection';
import { ServicesSection } from './components/ServicesSection';
import { PricingSection } from './components/PricingSection';
import { ReviewsSection } from './components/ReviewsSection';
import { ContactSection } from './components/ContactSection';
import { Footer } from './components/Footer';
import { TelegramButton } from './components/TelegramButton';
import { LegalModal } from './components/LegalModal';
export function App() {
  const [isLegalModalOpen, setIsLegalModalOpen] = useState(false);
  return <div className="min-h-screen bg-[#0A0A0A] font-sans selection:bg-red-500 selection:text-white" data-id="element-0">
      <Header data-id="element-1" />

      <main data-id="element-2">
        <HeroSection data-id="element-3" />
        <AboutSection data-id="element-4" />
        <ServicesSection data-id="element-5" />
        <PricingSection data-id="element-6" />
        <ReviewsSection data-id="element-7" />
        <ContactSection data-id="element-8" />
      </main>

      <Footer onOpenLegal={() => setIsLegalModalOpen(true)} data-id="element-9" />

      <TelegramButton data-id="element-10" />

      <LegalModal isOpen={isLegalModalOpen} onClose={() => setIsLegalModalOpen(false)} data-id="element-11" />
    </div>;
}